import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=263b87a6&"
import script from "./TakePicture.vue?vue&type=script&lang=js&"
export * from "./TakePicture.vue?vue&type=script&lang=js&"
import style0 from "./TakePicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports